import { compose } from 'redux'

import APPLICATION_SETTINGS from 'src/config/settings'

import { getTokenFromStorage } from './getTokenFromStorage'

export const getAccessTokenKey = () => {
  const ownerId = APPLICATION_SETTINGS.appIdentifier.ownerId
  return `_hp_mbe_${ownerId}_access_token`
}

export const getAccessToken = () => {
  return compose(getTokenFromStorage, getAccessTokenKey)()
}
